import { connect } from 'react-redux';
import React, { Fragment } from 'react';
import { Row, Input, FormGroup } from 'reactstrap';
import i18n from '../../../i18next';

import { capitalizeFirstLetter } from '../../../utils/CommonUtils';
import { loadCategories, resetCategories, loadProducts, resetCategoriesInCatProdReducer } from '../../../actions';
import {
    MENU_ITEM_TYPE_MENU,
    MENU_ITEM_TYPE_CATEGORY,
    MENU_ITEM_TYPE_PRODUCT,
    MENU_ITEM_TYPE_DEALS,
    MENU_ITEMS_TYPES_PLURALS
} from '../../../utils/Constants';
import BaseMenuItemScreen from './BaseMenuItemScreen';
import MenuItemsColumn from './MenuItemsColumn';

class MenuCategoryProductScreen extends BaseMenuItemScreen {
    constructor(props) {
        super(props);

        this.state = this.getInitialBaseState();
        this.state["menus"] = [];
        this.state["categories"] = [];
        this.state["products"] = [];
        this.state['menuDtos'] = [];
        this.state['categoryDtos'] = [];
        this.state['productDtos'] = [];

        this.changeMasterCheckboxState = this.changeMasterCheckboxState.bind(this);
        this.renderTitleRow = this.renderTitleRow.bind(this);
        this.isTitleRowChecked = this.isTitleRowChecked.bind(this);
        this.renderItemsChekbox = this.renderItemsChekbox.bind(this);
        this.isChecked = this.isChecked.bind(this);
        this.prepareCatProdIDsToStore = this.prepareCatProdIDsToStore.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.menusCategoriesProducts !== this.props.menusCategoriesProducts) {
            const newDtos = [];
            const newProductDtos = this.state.productDtos.slice(0);
            let isItemAlreadyInState = false;
            if (this.props.menusCategoriesProducts.products !== prevProps.menusCategoriesProducts.products) {
                const productDtos = this.props.menusCategoriesProducts.products.slice(0)

                productDtos.map(productProp => {
                    this.state.categoryDtos.map(categoryState => {
                        if (productProp.parentId === categoryState.id) {
                            newDtos.push(productProp);
                        }
                    });
                });

                newDtos.map(newDto => {
                    this.state.productDtos.map(productState => {
                        if (newDto.id === productState.id) {
                            isItemAlreadyInState = true;
                        }
                    });
                    if (!isItemAlreadyInState) {
                        newProductDtos.push(newDto);
                    }
                });
            }

            this.setState({
                ...this.state,
                menus: this.props.menusCategoriesProducts.menus,
                categories: this.props.menusCategoriesProducts.categories,
                products: this.props.menusCategoriesProducts.products,
                productDtos: !isItemAlreadyInState ? newProductDtos : this.state.productDtos
            });
        }
        // Sends categories and products object with IDs to parent state
        if (prevState.categoryDtos !== this.state.categoryDtos || prevState.productDtos !== this.state.productDtos) {
            let modifierQuestions = this.prepareCatProdIDsToStore();
            this.props.saveCatProdToParent(modifierQuestions);
        }
    }

    componentWillUnmount() {
        this.setState({
            menus: [],
            categories: [],
            products: [],
            menuDtos: [],
            categoryDtos: [],
            productDtos: []
        });

        this.props.resetCategoriesInCatProdReducer();
    }

    prepareCatProdIDsToStore() {
        let selectedCategoryAndProductIDs = [];
        let selectedCategories = this.state.categoryDtos.slice(0);
        selectedCategories.map(selectedCategory => {
            let selectedCatProdObject = {
                categoryId: selectedCategory.id,
                productIds: []
            };

            this.state.productDtos.map(productDto => {
                if (selectedCategory.id === productDto.parentId) {
                    selectedCatProdObject.productIds.push(productDto.id);
                }
            });

            selectedCategoryAndProductIDs.push(selectedCatProdObject);
        });

        return selectedCategoryAndProductIDs;
    }

    renderTitleRow(column) {

        return (
            <FormGroup check>
                <Input className='masterCheckboxes'
                    type="checkbox" name={`${column}AllCheckbox`} style={{ cursor: 'pointer', top: 2 }}
                    onChange={() => this.changeMasterCheckboxState(column)}
                    checked={this.isTitleRowChecked(column)}
                />
            </FormGroup>
        );
    }

    changeMasterCheckboxState(column) {
        const itemsTypePlural = MENU_ITEMS_TYPES_PLURALS[column];
        let newDtos = [];
        let newDtosArray = this.state[`${column}Dtos`].slice(0);

        this.state[itemsTypePlural].map(propsItem => {
            let isItemFoundInState = false;

            this.state[`${column}Dtos`].map(stateItem => {

                if (propsItem.id === stateItem.id) {
                    isItemFoundInState = true;
                }
            });

            if (!isItemFoundInState) {
                newDtos.push(propsItem);
            }
        });

        if (newDtos.length !== 0) { // add items
            newDtos.map(newDto => {
                newDtosArray.push(newDto);
            });
        } else { // remove items
            this.state[`${column}Dtos`].map(stateItem => {
                this.state[itemsTypePlural].map(propsItem => {
                    if (stateItem.id === propsItem.id) {
                        const indexOfItem = newDtosArray.indexOf(stateItem);
                        newDtosArray.splice(indexOfItem, 1);
                    }
                });
            });
        }

        this.setState({
            ...this.state,
            [`${column}Dtos`]: newDtosArray
        });
    }

    isTitleRowChecked(column) {
        const itemsTypePlural = MENU_ITEMS_TYPES_PLURALS[column];
        let itemsFoundInStateCount = 0;

        this.state[itemsTypePlural].map(propsItem => {
            this.state[`${column}Dtos`].map(stateItem => {
                if (propsItem.id === stateItem.id) {
                    itemsFoundInStateCount++;
                }
            });
        });

        if (this.state[itemsTypePlural].length === itemsFoundInStateCount && this.state[itemsTypePlural].length !== 0) {
            return true;
        } else {
            return false;
        }
    }

    renderTitleParagraph(column) {
        const { titleStyle } = styles;
        const columnNameChange = (this.state.activeCategory.posId === "-123" && column === MENU_ITEM_TYPE_PRODUCT) ? MENU_ITEM_TYPE_DEALS : column;

        return (
            <p style={titleStyle}>{i18n.t(`screens:menuConfigScreen.${columnNameChange}`)}</p>
        );
    }

    renderItemsChekbox(item, column) {
        const { itemsChekbox, itemsCheckboxInactive } = styles;
        const isActive = this.state[`active${capitalizeFirstLetter(column)}`].id === item.id;
        const changeStyleIfActive = isActive ? itemsChekbox : itemsCheckboxInactive;

        return (
            <FormGroup check>
                <Input className='childrenCheckboxes' disabled={!isActive}
                    type="checkbox" name={`${item.id}`} style={changeStyleIfActive}
                    onChange={() => this.changeChildrenCheckboxes(item, column, false)}
                    checked={this.isChecked(item, column)}
                />
            </FormGroup>
        );
    }

    isChecked(item, column) {
        let isTrueOrFalse = false;

        this.state[`${column}Dtos`].map(singleDto => {
            if (singleDto.id === item.id) {
                isTrueOrFalse = true;
            }
        });

        return isTrueOrFalse;
    }

    changeChildrenCheckboxes(item, column, checkOnly) {     // checkOnly does check element item onSelect but does not uncheck it if already selected
        const newDtos = this.state[`${column}Dtos`].slice(0);
        const newCategoryDtos = [];
        const newProductDtos = [];
        let isItemFoundInState = false;

        if (newDtos.length > 0) {
            newDtos.map(dto => {
                if (dto.id === item.id) { // if item is found in state we remove it
                    isItemFoundInState = true;
                    if (!checkOnly) {
                        this.removeItemFromState(newDtos, dto, column, newCategoryDtos, newProductDtos);
                    }
                }
            });
            if (!isItemFoundInState) { // if item is not found in state we add it
                this.addItemToState(newDtos, item, column, !this.state.discountNonDiscountableProducts);
            }
        } else {
            this.addItemToState(newDtos, item, column, !this.state.discountNonDiscountableProducts); // if state Dtos are empty we add items;
        }

        if (column === MENU_ITEM_TYPE_MENU && isItemFoundInState && !checkOnly) {
            this.setState({
                [`${column}Dtos`]: newDtos,
                categoryDtos: newCategoryDtos,
                productDtos: newProductDtos
            });
        } else if (column === MENU_ITEM_TYPE_CATEGORY && isItemFoundInState && !checkOnly) {
            this.setState({
                [`${column}Dtos`]: newDtos,
                productDtos: newProductDtos
            });
        } else {
            this.setState({
                [`${column}Dtos`]: newDtos
            });
        }
    }

    addItemToState(newDtos, item) {
        newDtos.push(item);
    }

    removeItemFromState(newDtos, dto, column, newCategoryDtos, newProductDtos) {
        newDtos.splice(newDtos.indexOf(dto), 1);

        if (column === MENU_ITEM_TYPE_MENU) {
            this.clearRelatedCategoriesState(newCategoryDtos);
        }

        if (column === MENU_ITEM_TYPE_MENU || column === MENU_ITEM_TYPE_CATEGORY) {
            this.clearRelatedProductsState(newProductDtos);
        }
    }

    clearRelatedCategoriesState(newCategoryDtos) {
        this.state.categoryDtos.map(stateItem => {
            let categoryFoundInProps = false;

            this.props.categories.map(propsItem => {
                if (propsItem.id === stateItem.id) {
                    categoryFoundInProps = true;
                }
            });

            if (!categoryFoundInProps) {
                newCategoryDtos.push(stateItem);
            }
        });
    }

    clearRelatedProductsState(newProductDtos) {
        this.state.productDtos.map(stateItem => {
            let productFoundInProps = false;

            this.props.products.map(propsItem => {
                if (propsItem.id === stateItem.id) {
                    productFoundInProps = true;
                }
            });

            if (!productFoundInProps) {
                newProductDtos.push(stateItem);
            }
        });
    }

    render() {
        const menuConfigColumns = [MENU_ITEM_TYPE_MENU, MENU_ITEM_TYPE_CATEGORY, MENU_ITEM_TYPE_PRODUCT];
        const doNotCallQuestions = true;
        const { restaurantId, posSettings } = this.props;

        return (
            <Fragment>
                <Row style={{ marginLeft: 0, marginRight: 0 }}>
                    {
                        menuConfigColumns.map((column, i) => {
                            const itemsTypePlural = MENU_ITEMS_TYPES_PLURALS[column];
                            const hideMasterCheckboxes = column === MENU_ITEM_TYPE_CATEGORY ? (this.state.activeMenu.name !== undefined ? false : true)
                                : (column === MENU_ITEM_TYPE_PRODUCT ? (this.state.activeCategory.name !== undefined ? false : true) : true);

                            return (
                                <MenuItemsColumn
                                    key={i}
                                    name={`${column}-menuItemsColumn`}
                                    hiddenRow={hideMasterCheckboxes}
                                    items={this.state[itemsTypePlural]}
                                    activeItem={this.state[`active${capitalizeFirstLetter(column)}`]}
                                    onSelect={(item) => {
                                        this.loadColumnsData(
                                            item,
                                            false,
                                            column,
                                            doNotCallQuestions,
                                            restaurantId,
                                            // posSettings.type.id === 7 ? true : undefined,
                                            true,
                                            (posSettings.type.supportCsvFiles || posSettings.type.id === 7)),
                                            this.changeChildrenCheckboxes(item, column, true)
                                    }}
                                    renderTitleRow={this.renderTitleRow(column)}
                                    renderTitleParagraph={this.renderTitleParagraph(column)}
                                    renderActionComponent={column === 'menu' ? null : this.renderItemsChekbox}
                                    sortDisabled={true}
                                    column={column}
                                    styles={styles}
                                />
                            );
                        })
                    }
                </Row>
                <div>
                    <p style={{ marginBottom: 0, fontSize: 14 }}>*{i18n.t('screens:answerScreen.mealDealsDisplay')}</p>
                </div>
            </Fragment>
        );
    }
}

export default connect(null, { loadCategories, resetCategories, loadProducts, resetCategoriesInCatProdReducer })(MenuCategoryProductScreen);

let styles = {
    containerStyle: {
        width: '100%',
        marginTop: 20,
        paddingLeft: 0,
        paddingRight: 0
    },
    containerColumn: {
        display: 'flex',
        flexWrap: 'nowrap',
        overflowX: 'auto'
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 15
    },
    addItemIcon: {
        cursor: 'pointer',
        width: 28
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    rowStyle: {
        width: '100%',
        height: 520,
        backgroundColor: '#F8F8F8',
        borderTop: '1px solid grey',
        marginRight: 0,
        marginLeft: 0,
        overflowY: 'auto'
    },
    titleColumn: {
        padding: '5px 5px 5px 0',
        flex: '0 0 calc(100% / 3)',
        maxWidth: 'calc(100% / 3)'
    },
    titleColumnRow: {
        marginLeft: 0,
        marginRight: 0
    },
    titleColumnRowCol: {
        paddingLeft: 0
    },
    titleStyle: {
        float: 'left',
        marginBottom: 0,
        marginLeft: 0
    },
    iconsColumn: {
        paddingRight: 0
    },
    listGroupItem: {
        background: 'none',
        borderBottom: '1px solid #dee2e7'
    },
    fullWidthStyle: {
        width: '100%',
        height: 'fit-content'
    },
    editStyle: {
        color: '#0288d1',
        height: 0,
        cursor: 'pointer'
    },
    activeStyle: {
        backgroundColor: 'white',
        color: "#0288D1"
    },
    selectedItem: {
        color: "#0288D1",
        cursor: 'pointer'
    },
    pointerEvents: {
        pointerEvents: 'none'
    },
    activeIconStyle: {
        color: "#0288D1"
    },
    inactiveStyle: {
        color: "#cccccf",
        cursor: 'pointer'
    },
    inactiveStyleItalics: {
        fontStyle: "italic",
        color: "#cccccf",
        cursor: 'pointer'
    },
    selectedItemItalics: {
        fontStyle: "italic",
        color: "#0288D1",
        cursor: 'pointer'
    },
    activeNotPublished: {
        fontStyle: "italic",
        cursor: 'pointer'
    },
    buttonFloatRight: {
        float: 'right'
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    marginRight: {
        marginRight: 10
    },
    publishBtnTxt: {
        marginLeft: 6
    },
    importPadding: {
        paddingLeft: 2
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/MenuCategoryProductScreen.js